import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import baseStyles from '../../../base/outline-element/outline-element.base.css.lit';
import sharedStyles from './ghs-styled-text-cke-five.css.lit';
import { LightController } from '../../../controllers/light-controller';
import { OutlineElement } from '../../../base/outline-element/outline-element';

export type TextVariant = 'default' | 'dark' | 'hero';
export type TextSizeVariant = 'small' | 'base';

/**
 * The WYSIWYG component for ckeditor 5
 * @element ghs-wysiwyg
 * @slot - default slot supplied by outline-wysiwyg
 */
@customElement('ghs-styled-text-cke-five')
export class GhsStyledTextCke5 extends OutlineElement {
  static styles: CSSResultGroup = [
    baseStyles, // Styles from outline-element. Primarily to include @tailwind base;
    sharedStyles, // Styles shared between Bellin and Gundersen.
  ];

  lightController = new LightController(
    this,
    GhsStyledTextCke5.styles,
    this.tagName.toLowerCase()
  );

  /**
   * Styled text variant.
   */
  @property({ type: String, attribute: 'variant', reflect: true })
  variant: TextVariant = 'default';

  /**
   * Size text variant.
   */
  @property({ type: String, reflect: true })
  size: TextSizeVariant = 'base';

  /**
   * Whether or not the host has a maxwidth set to limit line length.
   */
  @property({
    type: Boolean,
    reflect: true,
    attribute: 'max-width',
  })
  maxWidth = false;

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}
